import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const typesense = defineConnector({
  identifier: "typesense",
  name: "Typesense",
  tagLine: "Search engine for developers",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.typesense\\.org/.*",
  auth: (app) =>
    headerAuth([{ name: "X-TYPESENSE-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Use the admin API key from your [Typesense Cloud dashboard](https://cloud.typesense.org/) or your self-hosted Typesense configuration.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Typesense host",
          placeholder: "xyz.a1.typesense.net",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/health`,
  },
});
